import { auth } from "../services/firebase";



export function signup(email, password) {
    return auth().createUserWithEmailAndPassword(email, password);
}

export function signin(email, password) {
    return auth().signInWithEmailAndPassword(email, password);
}

export function signInWithEmail(email) {
    return auth().signInWithEmailLink(email, window.location.href);
}

export function signInWithGoogle() {
    const provider = new auth.GoogleAuthProvider();
    return auth().signInWithPopup(provider);
}

export function signInWithGitHub() {
    const provider = new auth.GithubAuthProvider();
    return auth().signInWithPopup(provider);
}

export function logout() {
    return auth().signOut();
}

export function sendPasswordLink(email, actionCodeSettings) {
  return auth().sendSignInLinkToEmail(email, actionCodeSettings);
}

export function isSignIn() {
  return auth().isSignInWithEmailLink(window.location.href);
}

export function resetPassword(newPassword) {
  const user = auth().currentUser;
  return user.updatePassword(newPassword);
}

export function sendVerification(user, actionCodeSettings) {
  return user.sendEmailVerification(actionCodeSettings);
}

    